import ApplicationAdapter from './application';
import DS from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class ExtApiKeyAdapter extends ApplicationAdapter {
  buildURL(
    modelName?: keyof ModelRegistry,
    id?: string,
    snapshot?: DS.Snapshot | any[] | null,
    requestType?: string,
    query?: string,
  ) {
    let url = super.buildURL(modelName, id, snapshot, requestType, query);

    // pass-through account scope paths for GET requests:
    // necessary due to API credentials views in UI being on account level (unknown environment)
    if (requestType === 'findAll' || requestType === 'findRecord') {
      return url;
    }

    // for all other operations, use env. ID set on the model:
    let envID = (snapshot as DS.Snapshot<'ext-api-key'>)?.belongsTo('environment')?.id;
    url = `${this.host}/${this.namespace}/environments/${envID}/ext_api_keys`;

    if (id) {
      url += `/${id}`;
    }

    return url;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'ext-api-key': ExtApiKeyAdapter;
  }
}
